import React, { useEffect, useState } from "react";
import { req } from "./api";
import { Field, Msg } from "./fields";

const STATUSES = ["received", "review", "feedback", "complete"];
const CATS = { profile: "Company profile", financials: "Financial statements", licences: "Licences & registrations", bank: "Bank statements", dpr: "DPR draft", other: "Other" };

export default function ClientDocs() {
  const [items, setItems] = useState(null);
  const [msg, setMsg] = useState("");

  const load = () => req("/admin/client-documents").then(setItems).catch((e) => { setMsg(e.message); setItems([]); });
  useEffect(() => { load(); }, []);

  const update = async (id, patch) => {
    try { await req(`/admin/client-documents/${id}`, { method: "PUT", body: patch }); load(); }
    catch (x) { setMsg(x.message); }
  };

  if (!items) return <p className="muted">Loading…</p>;
  return (
    <div>
      <Msg msg={msg} />
      <p className="muted" style={{ marginBottom: 18 }}>Documents uploaded by clients through the website's document desk. Changing a status emails the client.</p>
      {items.length ? (
        <div className="tbl-wrap"><table className="tbl" data-testid="client-docs-table">
          <thead><tr><th>Received</th><th>Client</th><th>Document</th><th>Type</th><th>Status</th><th></th></tr></thead>
          <tbody>{items.map((d) => (
            <React.Fragment key={d.id}>
              <tr>
                <td className="num">{new Date(d.createdAt).toLocaleString("en-GB", { day: "numeric", month: "short", hour: "2-digit", minute: "2-digit" })}</td>
                <td><strong>{d.clientName}</strong><div className="muted small">{d.clientOrg}</div><div className="muted small">{d.clientEmail}{d.clientPhone ? " · " + d.clientPhone : ""}</div></td>
                <td>{d.filename}<div className="muted small">{(d.size / 1024).toFixed(0)} KB{d.note ? " · “" + d.note + "”" : ""}</div></td>
                <td><span className="pill">{CATS[d.category] || d.category}</span></td>
                <td><select value={d.status || "received"} onChange={(e) => update(d.id, { status: e.target.value })} data-testid={`client-doc-status-${d.id}`}>
                  {STATUSES.map((s) => <option key={s} value={s}>{s}</option>)}
                </select></td>
                <td><div className="row-actions">
                  <a className="btn sm ghost" href={`/api/files/${d.storagePath}`} target="_blank" rel="noopener noreferrer" data-testid={`client-doc-dl-${d.id}`}>Download</a>
                </div></td>
              </tr>
              <tr><td colSpan={6} style={{ paddingTop: 0 }}>
                <input defaultValue={d.internalNote || ""} placeholder="Internal note (team only)"
                  onBlur={(e) => e.target.value !== (d.internalNote || "") && update(d.id, { internalNote: e.target.value })}
                  style={{ width: "100%", fontSize: 13 }} />
              </td></tr>
            </React.Fragment>))}</tbody></table></div>
      ) : <div className="empty">No client uploads yet. When clients upload documents through the site, they appear here.</div>}
    </div>
  );
}
